const DEVICE_ID_KEY = "sa_device_id";

export function getDeviceId(): string {
  let id = localStorage.getItem(DEVICE_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_KEY, id);
  }
  return id;
}

function parseBrowserFromUserAgent(ua: string): string {
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("OPR/") || ua.includes("Opera")) return "Opera";
  if (ua.includes("Firefox/")) return "Firefox";
  if (ua.includes("CriOS") || ua.includes("Chrome/")) return "Chrome";
  if (ua.includes("Safari/")) return "Safari";
  return "Browser";
}

function parseOsFromUserAgent(ua: string): string {
  if (ua.includes("Windows")) return "Windows";
  // iOS before Mac: iPhone/iPad UAs contain "like Mac OS X". (iPadOS 13+
  // Safari sends a desktop Macintosh UA by default and still reads as Mac.)
  if (ua.includes("iPhone") || ua.includes("iPad") || ua.includes("iOS"))
    return "iOS";
  if (ua.includes("Mac OS X") || ua.includes("Macintosh")) return "Mac";
  // Android before Linux: Android UAs also contain "Linux".
  if (ua.includes("Android")) return "Android";
  if (ua.includes("Linux")) return "Linux";
  return "Unknown";
}

// Prefers UA-CH (navigator.userAgentData) where available since the classic
// User-Agent string is being frozen/reduced by browsers; falls back to a
// small UA parse otherwise.
export function getDeviceName(): string {
  const uaData = (
    navigator as Navigator & {
      userAgentData?: { brands?: { brand: string }[]; platform?: string };
    }
  ).userAgentData;

  if (uaData?.brands?.length) {
    const brand =
      uaData.brands.find((b) => !/Not.A.Brand/i.test(b.brand))?.brand ??
      uaData.brands[0].brand;
    const platform = uaData.platform || parseOsFromUserAgent(navigator.userAgent);
    return `${brand} on ${platform}`.slice(0, 128);
  }

  const ua = navigator.userAgent || "";
  return `${parseBrowserFromUserAgent(ua)} on ${parseOsFromUserAgent(ua)}`.slice(
    0,
    128,
  );
}

export function getDeviceHeaders(): Record<string, string> {
  return {
    "X-Device-Id": getDeviceId(),
    "X-Device-Platform": "web",
    "X-Device-Name": getDeviceName(),
  };
}
